/**
 * Block deprecation
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-deprecation/
 * @see https://developer.wordpress.org/news/2023/03/block-deprecation-a-tutorial/
 */

import { RichText, useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { processNewsletterAttrs } from './save-extra';

const v3 = {
  supports: {
    html: false
  },
  attributes: {
    labelBackgroundColor: {
      type: 'string',
      default: '#ffffff'
    },
    newsletterAttrs: {
      default: {},
      type: 'object'
    },
    formStyle: {
      type: 'string',
      default: 'is-underline'
    }
  },
  save({ attributes }) {
    const {
      labelBackgroundColor,
      newsletterAttrs,
      formStyle
    } = attributes;

    const blockProps = useBlockProps.save({
      className: 'block__email-form'
    });

    const innerBlocksProps = useInnerBlocksProps.save({
      className: 'email-form__button'
    });

    let inputFields = null;

    if ( newsletterAttrs !== null ) {
      inputFields = processNewsletterAttrs( newsletterAttrs );
    }

    return (
      <div { ...blockProps }>
        <form className='email-form__form'>
          <label className='email-form__label flex' htmlFor='email'>
            <span
              className='email-form__label-text is-hidden'
              style={{ backgroundColor: labelBackgroundColor }}
            >
              { __( 'Email Address', 'dwt-custom-theme' ) }
            </span>
          </label>
          <RichText.Content
            className={`email-form__input w-full bg-transparent ${formStyle}`}
            tagName='input'
            id='email'
            type='email'
            name='email'
            placeholder={ __( 'Email Address', 'dwt-custom-theme' ) }
          />
          <p className='paragraph-3 error-message text-error-red is-hidden'></p>
          
          {/* Block button */}
          <div { ...innerBlocksProps } />
          { newsletterAttrs ? inputFields : null }
        </form>
      </div>
    );
  }
};

const v2 = {
  supports: {
    html: false
  },
  attributes: {
    labelBackgroundColor: {
      type: 'string',
      default: '#ffffff'
    },
    newsletterAttrs: {
      default: {},
      type: 'object'
    },
    formStyle: {
      type: 'string',
      default: 'is-underline'
    }
  },
  save({ attributes }) {
    const {
      labelBackgroundColor,
      newsletterAttrs,
      formStyle
    } = attributes;

    const blockProps = useBlockProps.save({
      className: 'block__email-form'
    });

    const innerBlocksProps = useInnerBlocksProps.save({
      className: 'email-form__button'
    });

    let inputFields = null;

    if ( newsletterAttrs !== null ) {
      inputFields = processNewsletterAttrs( newsletterAttrs );
    }

    return (
      <div { ...blockProps }>
        <form className='email-form__form'>
          <label className='email-form__label flex' htmlFor='email'>
            <span
              className='email-form__label-text is-hidden'
              style={{ backgroundColor: labelBackgroundColor }}
            >
              { __( 'Email Address', 'dwt-custom-theme' ) }
            </span>
          </label>
          <RichText.Content
            className={`email-form__input w-full bg-transparent ${formStyle}`}
            tagName='input'
            id='email'
            type='email'
            name='email'
            placeholder={ __( 'Email Address', 'dwt-custom-theme' ) }
          />
          <p className='paragraph-3 error-message text-error-red is-hidden'></p>
          
          {/* Block button */}
          <div { ...innerBlocksProps } />
          { newsletterAttrs ? inputFields : null }
        </form>
      </div>
    );
  }
};

const v1 = {
  supports: {
    html: false
  },
  attributes: {
    labelBackgroundColor: {
      type: 'string',
      default: '#ffffff'
    },
    newsletterAttrs: {
      default: {},
      type: 'object'
    }
  },
  save({ attributes }) {
    const {
      labelBackgroundColor,
      newsletterAttrs,
      formStyle
    } = attributes;

    const blockProps = useBlockProps.save({
      className: 'block__email-form'
    });

    const innerBlocksProps = useInnerBlocksProps.save({
      className: 'email-form__button'
    });

    let inputFields = null;

    if ( newsletterAttrs !== null ) {
      inputFields = processNewsletterAttrs( newsletterAttrs );
    }

    return (
      <div { ...blockProps }>
        <form className='email-form__form'>
          <label className='email-form__label flex' htmlFor='email'>
            <span
              className='email-form__label-text is-hidden'
              style={{ backgroundColor: labelBackgroundColor }}
            >
              { __( 'Email Address', 'dwt-custom-theme' ) }
            </span>
          </label>
          <RichText.Content
            className={`email-form__input w-full bg-transparent ${formStyle}`}
            tagName='input'
            id='email'
            type='email'
            name='email'
            placeholder={ __( 'Email Address', 'dwt-custom-theme' ) }
          />
          <p className='paragraph-3 error-message text-error-red is-hidden'></p>

          {/* Block button */}
          <div { ...innerBlocksProps } />
          { newsletterAttrs ? inputFields : null }
        </form>
      </div>
    );
  }
};

export default [ v3, v2, v1 ];
